
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { checkAppVersion, forceRefresh } from './utils/versionChecker'
import LogRocket from 'logrocket'
import logger from './utils/logger'
import PiwikPro from '@piwikpro/react-piwik-pro'
import { resetAllUsages } from './utils/trackToolAction'

// Initialiser Piwik Pro pour le tracking d'analytics
// Using the correct initialization method
PiwikPro.initialize('a3cd61a8-53e0-49a5-85e4-64ee9122c97c', 'https://braux.containers.piwik.pro');

// Add this line to make the window._paq array available globally
window._paq = window._paq || [];

// Expose resetAllUsages globally to ensure it's available in the console
if (typeof window !== 'undefined') {
  (window as any).resetAllUsages = resetAllUsages;
  (window as any).forceRefresh = forceRefresh; // Exposer la fonction de rafraîchissement forcé
}

logger.log('Piwik Pro initialized');

// Initialiser LogRocket uniquement en production
if (process.env.NODE_ENV === 'production') {
  LogRocket.init('iofzsb/staging-alunatools'); // ID d'application LogRocket officiel
  logger.log('LogRocket initialized in production');
} else {
  logger.log('LogRocket not initialized in development');
}

// Check application version on startup
checkAppVersion();

// Forcer un rafraîchissement complet lors de problèmes de synchronisation
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('refresh')) {
  forceRefresh();
}

// Créer une instance de QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Log pour confirmer que le provider est monté (uniquement en dev)
logger.log('QueryClientProvider est en cours d\'initialisation')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)
